module.exports = __webpack_public_path__ + "img/debug-button.ffcf8bc0.png";